import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class ModalCurrency extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currency: null
        };
    };

    componentWillMount() {
        this.setState({currency: this.props.currency});
    }

    _close(){
        this.props.setLeave(false, true);
    }

    _set(value){
        this.props.setLeave(value, false);
    }

    _renderText(item) {
        return langRegister.get("modal-currency", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          {
                              salesChannelRegister.get('name')!=='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon.svg")}/>
                          }
                          {
                              salesChannelRegister.get('name')==='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon_yl.svg")}/>
                          }
                          <div>
                              <div className={Styles.overlayModalTitle}>
                                  {this._renderText("item_1")}
                              </div>
                              <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.overlayModalText}>
                                  {this._renderText("item_4")}
                                  <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.overlayModalTextBold}>{" "}{this.state.currency}{" "}</span>
                                  {this._renderText("item_5")}
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => this._set(false)}
                                   className={Styles.overlayModalButtonsItemButton}>
                                  {this._renderText("item_2")}
                              </div>
                          </div>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set(this.state.currency)}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {this._renderText("item_3")}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalCurrency;


// WEBPACK FOOTER //
// ./src/components/modal-currency/component.js